module.exports = __webpack_public_path__ + "static/media/FOUR.f3a8436d.png";